import React from "react";
import { ProgressBarPortal } from "./ProgressBarPortal/ProgressBarPortal";
import type { MessageProp } from "interfaces/reports/sharedworker.types";

type ProgressBarProps = { messages: Map<string, MessageProp> };

export const ProgressBars = ({ messages }: ProgressBarProps) => {
  return (
    <>
      {[...messages].map(([nodeId, rest], index) => (
        <ProgressBarPortal
          key={nodeId}
          index={index}
          nodeId={nodeId}
          modalParams={rest.modalParams}
          requestId={rest.requestId}
          interval={rest.interval}
          status={rest.status}
        />
      ))}
    </>
  );
};
